//  actions
import TYPES from './types'

//  initialState
import initialState from './initialState'

// Model
import model from './model'

export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.FILTERS.UPDATE:
      return model.set(state, action.payload)
    case TYPES.FILTERS.DELETE:
      return initialState
    case TYPES.FILTERS.DELETE_ADVANCED:
      return model.deleteAdvancedFilters(state, action.payload)
    default:
      return state
  }
}
